import { categories } from '@/mocks/categories';
import { videos } from '@/mocks/videos';

export function formatCount(n: number): string {
  if (n >= 100000000) return `${(n / 100000000).toFixed(1)}亿`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export function getCategoryByKey(key: string) {
  return categories.find((c) => c.key === key);
}

export function getCategoryName(key: string): string {
  return getCategoryByKey(key)?.name ?? key;
}

export function getVideosByCategory(key: string) {
  return videos.filter((v) => v.category === key);
}

export function getVideoById(id: string) {
  return videos.find((v) => v.id === id);
}

export function getRelatedVideos(category: string, excludeId: string, count = 6) {
  const pool = videos.filter((v) => v.category === category && v.id !== excludeId);
  const shuffled = [...pool].sort(() => Math.random() - 0.5);
  if (shuffled.length >= count) return shuffled.slice(0, count);
  const extra = videos.filter((v) => v.id !== excludeId && v.category !== category);
  return [...shuffled, ...extra.sort(() => Math.random() - 0.5)].slice(0, count);
}

export function categoryCount(key: string): number {
  return videos.filter((v) => v.category === key).length;
}